import { timeframeSchema } from '../../schemas/misc/timeframe.ts'
import type { ViewQueryResultCursor } from '../../schemas/query/index.ts'

export type ViewResultCursorOrInitialCursor = Omit<ViewQueryResultCursor, 'nextId'> & {
  nextId?: string | null
}
export type SqlResultRecord = Record<string, unknown>

export const POSTGRES_COLUMN_LENGTH_LIMIT = 63

// 後から`_label`が付与されることがあるので、その分も確保する(63 - 6 = 57)
export const FIELD_NAME_LENGTH_LIMIT = POSTGRES_COLUMN_LENGTH_LIMIT - `_label`.length

// グラフ描画時に時間単位がprefixに付与される場合のバッファを確保する
// timeframesの最長文字列とアンダースコア1文字を考慮 e.g. "fiscal_quarter_"
const maxTimeframeLength = Math.max(...timeframeSchema.options.map((tf) => tf.length))
export const PROPERTY_DIMENSION_LENGTH_LIMIT_WITH_TIMEFRAME = POSTGRES_COLUMN_LENGTH_LIMIT - maxTimeframeLength - 1
